import { ContractTradeType } from "@/types";
import { contractsUIConfig } from "@/utils/Contracts";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

interface TradeIdentifierProps {
  tradeType: ContractTradeType;
  id: number;
  companyName?: string;
  productName?: string;
}

function TradeIdentifier({ tradeType, id, companyName, productName }: TradeIdentifierProps) {
  const { t } = useTranslation();
  const isBuy = tradeType === ContractTradeTypeEnum.BUY;
  const { tableIconName } = contractsUIConfig(tradeType);

  return (
    <div className={styles.root}>
      <SVGAsset name={tableIconName} height={24} width={24} style={{ display: "block", flexShrink: 0 }} />
      <div className={styles.idStack}>
        <Text display="technical" className={styles.idText}>
          #{id}
        </Text>
        <Text
          display="technical"
          className={styles.directionText}
          style={{ color: isBuy ? "var(--color-buy-primary)" : "var(--color-sell-primary)" }}
        >
          {t(`enumerables:contractTradeType.${tradeType}`)}
        </Text>
      </div>
      {companyName && (
        <Text strong className={styles.companyName} truncate="end">
          {companyName}
          {productName && (
            <Text span color="tertiary">
              {" "}
              — {productName}
            </Text>
          )}
        </Text>
      )}
    </div>
  );
}

export default TradeIdentifier;
